<template>
  <div id="backState" class="mt-8 w-full px-4 flex items-center justify-center">
    <button class="btn" type="button" @click="$emit('goBack')">
      Go Back
    </button>
  </div>
</template>

<script>
export default {
    name: "BackButton",
}
</script>

<style>
#backState .btn {
  background-color: #08697b;
  color: white;
  font-size: 16px;
  font-weight: bold;
  padding: 8px 16px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
}
</style>